(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ama-safe-util', {
            parent: 'admin',
            url: '/ama-safe-utils',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'eDocumentsApp.amaSafeUtil.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ama-safe-util/ama-safe-util.html',
                    controller: 'AmaSafeUtilController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('amaSafeUtil');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
